import { render, staticRenderFns } from "./PeriodeCreate.vue?vue&type=template&id=3d17f690&"
import script from "./PeriodeCreate.js?vue&type=script&lang=js&"
export * from "./PeriodeCreate.js?vue&type=script&lang=js&"
import style0 from "./PeriodeCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports